<template>
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="23"
    height="22"
    viewBox="0 0 23 22"
    fill="none"
  >
    <rect
      x="0.451172"
      y="0.222656"
      width="21.664"
      height="21.664"
      rx="10.832"
      fill="#F9FAFB"
    />
    <circle cx="11.2835" cy="11.056" r="3.61067" fill="#213F7A" />
  </svg>
</template>

<script>
export default {
  name: "IconStepperActive",
};
</script>

<style></style>
